// Polyfills
//import "./polyfills";
import "core-js/stable";
import "regenerator-runtime/runtime";

// CreateJS lib imports
import "tweenjs/lib/tweenjs";
createjs.Ticker.timingMode = createjs.Ticker.RAF;
createjs.Ticker.maxDelta = 100;

// PixiJS lib imports
import "pixi-spine";
import "pixi-particles";

// Make app bootstrap method available to window scope.
import { app, initApp } from "./app";
import { env } from "./env";
window.initApp = function (config) {
    if (!app) initApp(config);
};

initApp();

export { app, env };
